// Hero images configuration
// Add new images to this array and they'll automatically be used in both Home and LandingPage
export const heroImages = [
  '/assets/cory.jpeg',
  '/assets/cory2.jpeg',
  '/assets/hero-img.jpg',
  '/assets/hero.jpg'
];

// Helper function to get a random hero image
export const getRandomHeroImage = () => {
  const randomImage = heroImages[Math.floor(Math.random() * heroImages.length)];
  return `${randomImage}?t=${new Date().getTime()}`;
}; 